import {ChangeDetectionStrategy, Component, ViewEncapsulation, inject, Input} from '@angular/core';
import {ExplorerService} from '../../services/explorer.service';
import {map} from 'rxjs/operators';
import {INode} from '../../shared/types';
import {AsyncPipe, JsonPipe, NgClass, NgTemplateOutlet} from '@angular/common';
import {TablerIconsModule} from 'angular-tabler-icons';
import { CONFIG } from '../../shared/providers';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { TranslateModule } from '@ngx-translate/core';
import { FolderNamePipe } from '../../shared/folder-name.pipe';
import { isCallArchiveRoot } from '../../shared/display';

@Component({
  selector: 'nxe-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgTemplateOutlet, NgClass, AsyncPipe, TablerIconsModule, TranslateModule, FolderNamePipe],
})
export class TreeComponent {
  @Input() showFileTree: boolean = false;

  private explorerService = inject(ExplorerService);
  protected treeNodes: INode[] = [];
  protected tree$ = this.explorerService.root$.pipe(map((r) => r.children));
  protected selectedId$ = this.explorerService.openedDir$.pipe(map((p) => p?.id));
  protected rootId$ = this.explorerService.root$.pipe(map((r) => r.id));

  // private config = inject(CONFIG);
  // protected homeNodeName = this.config.homeNodeName
  buttonHome$ = this.explorerService.homeButton$.pipe(map((b) => b));

  open(node: INode) {
    this.explorerService.openNode(node.id);
  }
  home() {
    this.explorerService.openNode(0);
  }

  expand(event: Event, node: INode) {
    event.preventDefault();
    event.stopPropagation();
    this.explorerService.expand(node.id);
  }

  collapse(event: Event, node: INode) {
    event.preventDefault();
    event.stopPropagation();
    this.explorerService.collapse(node.id);
  }

  /** Cartella radice "Conversazioni chiamate" (aspetto dedicato). */
  isArchiveRoot(node: INode): boolean {
    return isCallArchiveRoot(node);
  }

  select(node: INode) {

  }

  // onDrop(event: CdkDragDrop<INode[]>, targetNode: INode) {
  onDrop(event: any, targetNode: INode) {
  const moved = event.item.data; // il file/cartella spostato
  console.log('onDrop', event.item, targetNode)
  // this.dataService.moveNode(moved.id, targetNode.id).subscribe(() => {
  //   this.explorerService.refreshExplorer();
  // });
}
}
